<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
    Comment
</h2>

<mat-dialog-content style="padding: 10px;" [formGroup]="formGroup">
    <div [innerHtml]="message"></div>

    <lgd-text controlName="value">
    </lgd-text>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" telemetry="Submission-PromptCancel">
        {{cancelLabel}}
    </button>

    <button mat-button color="primary" [disabled]="formGroup.invalid" (click)="close()"
            telemetry="Submission-PromptAccept">
        {{okLabel}}
    </button>
</mat-dialog-actions>